import React from 'react'
import MenuButton from '../componentKit/MenuButton'
import CSSModules from 'react-css-modules'
import styles from './menuItem.css'

const MenuItem = ({ item, dayId, active, onClick, unReadMsgs }) => {
    let link = '/' + item.link
    if(!item.link){
        link = '/'
    }
 /*   if(item.link == 'chats'){
        link = '/' + item.link + '/' + dayId
    }*/

    return (
    <li className={item.active ? styles.mainNavItemActive : styles.mainNavItem}>
        <MenuButton
            link={link}
            icon={item.icon}
            onClick={onClick}
            unReadMsgs={item.link == 'chats' ? unReadMsgs : null}
        >
            {item.name}
        </MenuButton>
    </li>)
}

export default CSSModules(MenuItem, styles)



// WEBPACK FOOTER //
// /var/www/build-health-2/src/components/todayTask/MenuItem.js